import type { CoverageRule, ServiceId } from "./types"

export interface InsurerLogo {
  url: string
  alt?: string
}

export interface InsurerPackage {
  id: string
  name: string
  coverage: Partial<Record<ServiceId, CoverageRule>>
}

export interface Insurer {
  id: string
  name: string
  /** Insurer logo from the CMS `media` relation. Null when none is set. */
  logo: InsurerLogo | null
  packages: InsurerPackage[]
}

export interface InsurersData {
  services: {
    id: ServiceId
    name: string
    name_de: string
    name_en: string
    name_fr: string
    price: number
  }[]
  insurers: Insurer[]
}

export function findInsurer(
  data: InsurersData,
  id: string
): Insurer | undefined {
  return data.insurers.find((i) => i.id === id)
}

export function findPackage(
  data: InsurersData,
  insurerId: string,
  packageId: string
): InsurerPackage | undefined {
  return findInsurer(data, insurerId)?.packages.find((p) => p.id === packageId)
}
